import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Allbookingreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);
    const [serviceData, setserviceData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [total, settotal] = useState(0);

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }

                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    const getReport = async () => {
        if (!fromDate || !toDate) {
            Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
            return;
        }

        setloading(true);
        setbookingData([]);
        setpaymodes([]);
        setpayhistory([]);

        const startOfDay = new Date(fromDate);
        startOfDay.setHours(0, 0, 0, 0);
        const endOfDay = new Date(toDate);
        endOfDay.setDate(endOfDay.getDate() + 1); // Next day for exclusive range

        const reportDate = moment(fromDate).format('YYYY-MM-DD');

        // =====================================================================================================================================
        // 1. Fetch both bookings and payhistory in parallel
        const [payHistorySnapshot, serviucesSnapshot] = await Promise.all([
            getDocs(
                query(
                    collection(db, "payhistory"),
                    where("createdAt", ">=", startOfDay),
                    where("createdAt", "<", endOfDay),
                    where("paymenttype", "==", "B"),
                    where("status", "==", "Working"),
                )
            ),
            getDocs(
                query(
                    collection(db, "bookingservices"),
                    where("type", "==", "Booking"),
                    where("createdAt", ">=", startOfDay),
                    where("createdAt", "<", endOfDay),
                )
            )
        ]);


        // 3. Process payhistory data with paymode lookups
        const payHistoryDataPromises = payHistorySnapshot.docs.map(async (doc1) => {
            const docData = doc1.data();
            const [paymode1Snap, paymode2Snap, bookingSnap] = await Promise.all([
                getDoc(doc(db, "paymentmodes", docData.paymode1)),
                getDoc(doc(db, "paymentmodes", docData.paymode2)),
                getDoc(doc(db, "bookings", docData.bookingid))
            ]);

            const paymode1 = paymode1Snap.exists() ? paymode1Snap.data().paymode : "";
            const paymode2 = paymode2Snap.exists() ? paymode2Snap.data().paymode : "";
            const date = docData.createdAt.toDate();
            const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;

            let bookingData = {};
            if (bookingSnap.exists()) {
                const bookingDocData = bookingSnap.data();
                bookingData = {
                    rooms: bookingDocData.rooms || [], // Fetch rooms array
                    checkinDate: bookingDocData.checkindate ? bookingDocData.checkindate : null, // Convert checkindate
                    checkoutDate: bookingDocData.checkoutdate ? bookingDocData.checkoutdate : null, // Convert checkoutdate
                    custName: bookingDocData.customers && bookingDocData.customers.custname ? bookingDocData.customers.custname : "" // Fetch customer name
                };
            }

            return {
                id: doc1.id,
                data: docData,
                paymode1,
                paymode2,
                createdat: formattedDate,
                bookingData
            };
        });
        const payHistoryData = await Promise.all(payHistoryDataPromises);
        setpayhistory(payHistoryData);

        // 2. Process booking data
        const serviceData = serviucesSnapshot.docs.map((doc) => {
            const data = doc.data();
            const createdAt = data.createdAt;
            const entryTime = createdAt ? createdAt.toDate() : null;
            const entryTimeFomat = moment(entryTime).format('DD-MM-YYYY hh:mm:ss A');

            return {
                id: doc.id,
                data: data,
                entryTime: entryTimeFomat,  // Add the entryTime field
            };
        });
        setserviceData(serviceData);

        // 4. Fetch all payment modes and their totals concurrently
        const paymentModesSnapshot = await getDocs(collection(db, "paymentmodes"));
        const paymentModeIds = paymentModesSnapshot.docs.map((doc) => doc.id);

        // Query payhistory for each payment mode for both paymode1 and paymode2 in parallel
        const totalAmountPromises = paymentModeIds.map(async (paymodeId) => {
            const [paymode1TotalSnapshot, paymode2TotalSnapshot] = await Promise.all([
                getDocs(
                    query(
                        collection(db, "payhistory"),
                        where("paymode1", "==", paymodeId),
                        where("createdAt", ">=", startOfDay),
                        where("createdAt", "<", endOfDay),
                        where("paymenttype", "==", "B"),
                        where("status", "==", "Working"),
                    )
                ),
                getDocs(
                    query(
                        collection(db, "payhistory"),
                        where("paymode2", "==", paymodeId),
                        where("createdAt", ">=", startOfDay),
                        where("createdAt", "<", endOfDay),
                        where("paymenttype", "==", "B"),
                        where("status", "==", "Working"),
                    )
                )
            ]);

            // Compute the total amount for this payment mode
            const total1 = paymode1TotalSnapshot.docs.reduce((sum, doc) => sum + (doc.data().amount1 || 0), 0);
            const total2 = paymode2TotalSnapshot.docs.reduce((sum, doc) => sum + (doc.data().amount2 || 0), 0);

            const paymode = paymentModesSnapshot.docs.find(doc => doc.id === paymodeId)?.data().paymode || "";

            return {
                id: paymodeId,
                paymode,
                totalamount: (total1 + total2).toFixed(2)
            };
        });

        const paymentData = await Promise.all(totalAmountPromises);
        setpaymodes(paymentData);

        const totalAmount = paymentData.reduce((sum, data) => sum + parseFloat(data.totalamount), 0);
        settotal(totalAmount.toFixed(0));

        // ===================================================================================================================================

        // Query payment history
        const q1 = query(
            collection(db, 'payhistory'),
            where('status', '==', 'Working'),
            where('createdAt', '>=', Timestamp.fromDate(startOfDay)),
            where('createdAt', '<', Timestamp.fromDate(endOfDay))
        );

        const payhistorySnapshot = await getDocs(q1);
        const paymentHistoryData = await Promise.all(payhistorySnapshot.docs.map(async (doc1) => {
            const data = doc1.data();
            const [paymode1Snap, paymode2Snap] = await Promise.all([
                getDoc(doc(db, "paymentmodes", data.paymode1)),
                getDoc(doc(db, "paymentmodes", data.paymode2))
            ]);
            const paymode1 = paymode1Snap.exists() ? paymode1Snap.data().paymode : "";
            const paymode2 = paymode2Snap.exists() ? paymode2Snap.data().paymode : "";
            const date = data.createdAt.toDate();
            const createdat = moment(date).format('DD-MM-YYYY HH:mm:ss'); // Format date

            return {
                id: doc1.id,
                data,
                paymode1,
                paymode2,
                amount1: data.amount1 || 0, // Amount associated with paymode1
                amount2: data.amount2 || 0, // Amount associated with paymode2
                createdat
            };
        }));


        const checkinDetailsCheckoutQuery = query(
            collection(db, 'checkindetails'),
            where('status', '==', 'Checkout'),
            where('checkindate', '==', reportDate)
        );

        const checkinDetailsBookedQuery = query(
            collection(db, 'checkindetails'),
            where('status', '==', 'Booked'),
            where('checkindate', '==', reportDate)
        );

        // Fetch checkin details in parallel
        const [checkinDetailsCheckoutSnapshot, checkinDetailsBookedSnapshot] = await Promise.all([
            getDocs(checkinDetailsBookedQuery),
            getDocs(checkinDetailsCheckoutQuery),
        ]);

        // Combine data from both statuses and ensure uniqueness by bookingid
        const checkinDetailsData = [
            ...checkinDetailsCheckoutSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
            ...checkinDetailsBookedSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        ];

        const uniqueCheckinDetails = Array.from(
            new Map(checkinDetailsData.map(item => [item.bookingid, item])).values()
        );

        const bookingIds = uniqueCheckinDetails.map(doc => doc.bookingid);
        if (bookingIds.length === 0) {
            console.log("No bookings found for the specified report date.");
            return;
        }

        // Query bookings table using the bookingIds from checkindetails
        const bookingsQuery = query(
            collection(db, 'bookings'),
            where('__name__', 'in', bookingIds) // Assuming bookingId corresponds to the document ID in bookings
        );

        const bookingsSnapshot = await getDocs(bookingsQuery);
        const bookingsDataMap = bookingsSnapshot.docs.reduce((acc, doc) => {
            acc[doc.id] = { id: doc.id, ...doc.data() }; // Store entire booking data
            return acc;
        }, {});

        // Create a map of payment history by bookingId
        const paymentHistoryMap = paymentHistoryData.reduce((acc, pay) => {
            const bookingId = pay.data.bookingid;

            // Only consider this entry if bookingId exists in bookingsDataMap
            if (bookingsDataMap[bookingId]) {
                if (!acc[bookingId]) {
                    acc[bookingId] = [];
                }
                acc[bookingId].push(pay); // Store payment history related to bookingId
            }
            return acc;
        }, {});

       
        const combinedData = await Promise.all(uniqueCheckinDetails.map(async (checkinDetail) => {
            const bookingData = bookingsDataMap[checkinDetail.bookingid] || null;
        
            // Ensure bookingData exists before accessing its properties
            if (!bookingData) {
                console.warn(`No booking found for booking ID: ${checkinDetail.bookingid}`);
                return null; // Skip this entry if bookingData is null
            }
        
            // Fetch user details using uid from checkindetails
            let username = "Unknown User";
            if (checkinDetail.uid) {
                const userSnap = await getDoc(doc(db, "users", checkinDetail.uid));
                if (userSnap.exists()) {
                    username = userSnap.data().username || "Unnamed User";
                }
            }
        
            const roomamount = bookingData.rooamount || 0;
            const date1 = moment(bookingData.checkindate, 'YYYY-MM-DD');
            const date2 = moment(reportDate, 'YYYY-MM-DD');
        
            let dayDifference = date2.diff(date1, 'days');
            if (dayDifference === 0) {
                dayDifference = 1;
            }
        
            const serviceamount = parseFloat(bookingData?.serviceamount) / parseFloat(bookingData.noofdays) || 0;
        
            const q = query(
                collection(db, 'orders'),
                where('status', '==', 'Bill Pending'),
                where('orderdate', '==', reportDate),
                where('bookingId', '==', checkinDetail.bookingid)
            );
        
            // Fetch documents and calculate the sum of totalamount (for food)
            const querySnapshot = await getDocs(q);
            let foodTotal = 0;
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                foodTotal += data.totalamount || 0; // Ensure 'totalamount' exists
            });
        
            // Payment history calculation
            let paymentHistory = paymentHistoryMap[checkinDetail.bookingid] || [];
            let paidAmount = paymentHistory.reduce((sum, pay) => sum + pay.amount1 + pay.amount2, 0);
        
            let totalamount = parseFloat(roomamount) + parseFloat(serviceamount) + parseFloat(foodTotal);
            let alltoal = parseFloat(totalamount) * parseFloat(dayDifference);
            let remaining = parseFloat(alltoal) - parseFloat(paidAmount);
        
            return {
                ...checkinDetail,
                booking: bookingData,
                username, // Add the fetched username
                serviceamount,
                roomamount: roomamount.toFixed(0),
                foodamount: foodTotal.toFixed(0),
                totalamount: totalamount.toFixed(0),
                alltoal: alltoal.toFixed(0),
                paidamount: paidAmount.toFixed(0),
                pending: remaining.toFixed(0),
                todayDays: dayDifference,
                paymentHistory
            };
        }));
        
        // Remove null values from the final result
        setbookingData(combinedData.filter(item => item !== null));
        
        setloading(false);
    };

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| All Booking Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label>From Date</label>
                                                <input type='date' value={fromDate} onChange={handleFromDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-4'>
                                                <label>To Date</label>
                                                <input type='date' value={toDate} onChange={handleToDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card card-primary card-outline" ref={printRef}>
                                    <div className="card-body">
                                        <div className="row invoice-info">
                                            <div className="col-sm-12 invoice-col text-center">
                                                <address>
                                                    <h4>Dasara Executive</h4>
                                                    Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                    Phone: +91 9975294940 |
                                                    Email:  dasaraexecutive@gmail.com<br />
                                                    Website:  www.dasaraexecutive.com
                                                </address>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <table className='customers2 '>
                                                <tr>
                                                    <th style={{ textAlign: "center" }}>From Date : {moment(fromDate).format('DD/MM/YYYY')}  </th>
                                                    <th style={{ textAlign: "center" }}><h5>BOOKING REPORT </h5></th>
                                                    <th style={{ textAlign: "center" }}>To Date : {moment(toDate).format('DD/MM/YYYY')}</th>
                                                </tr>
                                            </table>

                                            <table className="customers2">
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#E0FCFE" }} colSpan={14}>Booking Report</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Sr No</th>
                                                        <th>Customer Name </th>
                                                        <th>Checkin Date </th>
                                                        <th>Checkout Date </th>
                                                        <th> Days </th>
                                                        <th>Rooms </th>
                                                        <th style={{ textAlign: "right" }}>Amount </th>
                                                        <th style={{ textAlign: "right" }}>Extra </th>
                                                        <th style={{ textAlign: "right" }}>Food</th>
                                                        <th style={{ textAlign: "right" }}>Total</th>
                                                        <th style={{ textAlign: "center" }}>Payments</th>
                                                        <th>Username</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        bookingData.map((item, num = 1) => {
                                                            return (
                                                                <tr key={num + 1}>
                                                                    <td width="80">{num + 1}</td>
                                                                    <td style={{ textTransform: "capitalize" }}>{item.booking.customers.custname}</td>
                                                                    <td>{moment(item.checkindate).format('DD/MM/YYYY')} {item.checkintime}</td>
                                                                    <td>{moment(item.checkoutdate).format('DD/MM/YYYY')} {item.checkouttime}</td>
                                                                    <td> 1</td>
                                                                    <td>
                                                                        {item.booking.rooms.map((item1, index) =>
                                                                            <span key={index}>&nbsp; {item1.roomname} ({parseFloat(item1.discount)}%)<br /> </span>
                                                                        )}
                                                                    </td>
                                                                    <td style={{ textAlign: "right" }}>{item.roomamount}</td>
                                                                    <td style={{ textAlign: "right" }}>{item.serviceamount}</td>
                                                                    <td style={{ textAlign: "right" }}>{item.foodamount}</td>
                                                                    <td style={{ textAlign: "right" }}>{item.totalamount}</td>
                                                                    <td style={{ textAlign: "right" }}>

                                                                        {
                                                                            item.paymentHistory.length > 0 ?
                                                                                <>
                                                                                    {
                                                                                        item.paymentHistory.map((itemmm, index) =>
                                                                                            <>
                                                                                                {
                                                                                                    parseFloat(itemmm.data.amount1) > 0 &&
                                                                                                    <b>{itemmm.paymode1} : {parseFloat(itemmm.data.amount1).toFixed(0)} <br /></b>
                                                                                                }
                                                                                                {
                                                                                                    parseFloat(itemmm.data.amount2) > 0 &&
                                                                                                    <b>{itemmm.paymode2} : {parseFloat(itemmm.data.amount2).toFixed(0)}</b>
                                                                                                }
                                                                                            </>
                                                                                        )
                                                                                    }
                                                                                </> :
                                                                                <b style={{ color: "red" }}>Pending</b>
                                                                        }

                                                                    </td>
                                                                    <td>
                                                                     {item.username}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        )}
                                                    {/* <tr>
                                                        <th colSpan={5} style={{ textAlign: "right" }}> TOTAL</th>
                                                        <th>{roomscount} </th>
                                                        <th style={{ textAlign: "right" }}>{allllroomamount} </th>
                                                        <th style={{ textAlign: "right" }}>{allllserviuceamount} </th>
                                                        <th style={{ textAlign: "right" }}>{allllfoodamount} </th>
                                                        <th style={{ textAlign: "right" }}>{alllltotalamount} </th>
                                                        <th style={{ textAlign: "right" }}></th>
                                                        <th></th>
                                                    </tr> */}
                                                </tbody>
                                            </table>

                                            <table className="customers2">
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#E0FCFE" }} colSpan={14}>Collection Report</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Custname</th>
                                                        <th>Room</th>
                                                        <th>Checkin</th>
                                                        <th>Checkout</th>
                                                        <th>Paymode1</th>
                                                        <th>Amount1</th>
                                                        <th>Paynote1</th>
                                                        <th>Paymode2</th>
                                                        <th>Amount2</th>
                                                        <th>Paynote2</th>
                                                        <th>Datetime</th>
                                                        <th>Note</th>
                                                         <th>Username</th>
                                                        {/* <th></th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        payhistory.map((item, index) =>
                                                            <tr key={index}>
                                                                <td>{item.bookingData.custName}</td>
                                                                <td>
                                                                    {item.bookingData.rooms.map((item1, index) =>
                                                                        <span key={index}>{item1.roomname} <br />  </span>
                                                                    )}
                                                                </td>
                                                                <td>{moment(item.bookingData.checkinDate).format('DD-MM-YYYY')}</td>
                                                                <td>{moment(item.bookingData.checkoutDate).format('DD-MM-YYYY')}</td>
                                                                <td>{item.paymode1}</td>
                                                                <td>{item.data.amount1}</td>
                                                                <td>{item.data.paytime1}</td>
                                                                <td>{item.paymode2}</td>
                                                                <td>{item.data.amount2}</td>
                                                                <td>{item.data.paytime2}</td>
                                                                <td>{item.createdat}</td>
                                                                <td>{item.data.note}</td>
                                                                <td>{item.data.username}</td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                            <table className='customers2'>
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#E0FCFE" }} colSpan={paymodes.length + 1}>Paymode Wise Collection</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Paymodes</th>
                                                        {
                                                            paymodes.map((item, index) =>
                                                                <>
                                                                    {
                                                                        item.totalamount > 0 &&
                                                                        <th key={index}>{item.paymode}</th>
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <th>Amount</th>
                                                        {
                                                            paymodes.map((item, index) =>
                                                                <>
                                                                    {
                                                                        item.totalamount > 0 &&
                                                                        <th key={index}>{item.totalamount}</th>
                                                                    }
                                                                </>
                                                            )
                                                        }

                                                    </tr>
                                                </thead>
                                            </table><br />
                                            <table className='customers2'>
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#E0FCFE" }}> <h6> Total Collection:  Rs. {total} /- </h6></th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                                <center>
                                    <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                </center>
                            </div>
                        </div>
                    </div>
                </section >

            </div>

        </div >

    )
}

export default Allbookingreport
